import React from 'react'

function Careers() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins lg:m-[100px] mt-5">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Careers</h2>
      <d iv className="space-y-8 max-w-4xl">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">News Coordinator</h3>
            <p className="text-sm text-white mt-4">We are looking for a News Coordinator to help manage our daily content and ensure the latest financial news reaches our audience. The ideal candidate has excellent organizational skills and a passion for financial news.</p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Social Media Content Manager</h3>
            <p className="text-sm text-white mt-4">As a Social Media Content Manager, you'll be responsible for creating and curating engaging content to grow our online presence across platforms. If you're passionate about finance and have experience managing social media campaigns, we'd love to hear from you.</p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Freelance Content Writers</h3>
            <p className="text-sm text-white mt-4">We are looking for Freelance Content Writers with expertise in finance and trading to contribute articles, blogs, and guides. If you have a talent for writing and a deep understanding of financial markets, this is the opportunity for you.</p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Product Manager</h3>
            <p className="text-sm text-white mt-4">Join our dynamic team as a Product Manager to lead the development and launch of innovative products in the financial space. Ideal candidates will have strong project management skills and a background in finance or technology.</p>
          </div>
        </div>
      </d>
    </div>
  )
}

export default Careers;
